export function ApiDiagram() {
  return <svg className="software-diagram" viewBox="20 34 320 252" fill="none" aria-hidden="true" data-art-style="flat">
    <g stroke="#8aa8c2" strokeWidth="1.5" strokeLinejoin="round">
      <path d="M68 88v44h44m180-44v44h-44M68 232v-44h44m180 44v-44h-44" />
    </g>
    <g stroke="#0082e5" strokeWidth="1.5" strokeLinejoin="round">
      <rect x="112" y="112" width="136" height="96" rx="4" fill="#edf5fc" />
      <path d="M112 134h136" stroke="#cfdfee" />
      <path d="m106 128 6 4-6 4m148-8-6 4 6 4m-148 48 6 4-6 4m148-8-6 4 6 4" />
      {[[24, 38], [248, 38], [24, 232], [248, 232]].map(([x, y], i) => <g key={i} transform={`translate(${x} ${y})`}>
        <rect width="88" height="50" rx="4" fill="#fff" />
        <path d="M0 16h88" stroke="#cfdfee" />
        <path d="M13 29h28m-28 9h20" strokeLinecap="round" />
        <rect x="59" y="27" width="16" height="12" rx="2" fill="#edf5fc" />
      </g>)}
    </g>
    <g fill="#8aa8c2">
      <circle cx="122" cy="123" r="2" />
      <circle cx="130" cy="123" r="2" />
      <circle cx="138" cy="123" r="2" />
    </g>
    <path d="m157 154-14 15 14 15m46-30 14 15-14 15m-17-33-12 36" stroke="#075dd5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}

export function PidDiagram({ labels = ['Proportional', 'Integral', 'Derivative'] }) {
  return <svg className="software-diagram" viewBox="30 16 420 334" fill="none" aria-hidden="true" data-art-style="flat">
    <path d="M42 38h396M42 78h396M42 118h396M42 158h396M42 198h396M42 238h396M82 28v220M146 28v220M210 28v220M274 28v220M338 28v220M402 28v220" stroke="#cfdfee" />
    <path d="M42 226V78h396" stroke="#8aa8c2" strokeWidth="1.5" strokeDasharray="5 5" />
    <path d="M42 226C90 226 105 132 154 102S242 80 292 78H438" stroke="#365577" strokeWidth="2.5" strokeLinecap="round" />
    <path className="software-pid-control-curve" pathLength="1" d="M42 226C76 226 80 20 124 34S157 139 195 117 226 55 265 70 303 98 335 88 373 72 400 77 422 80 438 78" stroke="#0082e5" strokeWidth="4" strokeLinecap="round" />
    <g stroke="#0082e5" strokeWidth="1.5" strokeLinejoin="round">
      <path d="M54 295h16m112 0h8m112 0h8m112 0h16M70 295l-6-4m6 4-6 4m120-4-6-4m6 4-6 4m120-4-6-4m6 4-6 4" />
      {labels.map((label, index) => <g key={index} data-pid-term={index}>
        <rect x={70 + index * 120} y="273" width="112" height="44" rx="4" fill="#fff" />
        <text x={126 + index * 120} y="300" textAnchor="middle" fontSize="15" fontWeight="550" fill="#075dd5" stroke="none">{label}</text>
      </g>)}
      <path d="M438 295v42H54v-42" />
    </g>
  </svg>
}

export function BuildingDiagram() {
  return <svg className="software-diagram" viewBox="0 0 400 300" fill="none" aria-hidden="true" data-art-style="flat-city">
    <g stroke="#1674cf" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M48 83c-9 0-10-14 0-15 4-11 20-11 24 0 13-3 19 15 7 15Z" fill="#fff" />
      <path d="M181 115c-14 0-17-20-3-22 3-16 25-17 31-4 13-8 28 0 28 12 12-1 16 14 5 14Z" fill="#fff" />
      <path d="M109 53q7-8 14 0 6-7 12-5M146 79q7-5 11 3 7-5 13-1" />
      <g data-building="tower">
        <path d="M259 66h106v209H259Z" fill="#E5F4FF" />
        <path d="M259 66h59v209h-59Z" fill="#ffffff" />
        <path d="M249 54h124v12H249Z" fill="#fff" />
        <path d="M352 54h21v12h-21Z" fill="#c7e6f5" />
        {[[276, 79], [276, 132], [276, 185], [276, 238], [334, 79], [334, 132]].map(([x, y]) =>
          <rect key={`${x}-${y}`} x={x} y={y} width="19" height="28" fill={x < 318 ? '#BFE7F7' : '#45BFF4'} />)}
        <path d="M249 111h124v11H249Z" fill="#fff" />
        <path d="M352 111h21v11h-21Z" fill="#c7e6f5" />
        <path d="M327 224h47v51h-47Z" fill="#ffffff" />
        <path d="M344 246h17v29h-17Z" fill="#BFE7F7" />
        <path d="M344 213c-8-8-2-25 1-28 4 7 10 18 6 27m4 1c-10-9-2-41 5-48 8 11 16 39 6 48Z" fill="#69bcef" />
        <path d="M360 189v25m-6-11 6 5 6-6" />
        <path d="M319 213h62v11h-62Z" fill="#fff" />
      </g>
      <g data-building="annex">
        <path d="M148 212h98v63h-98Z" fill="#E5F4FF" />
        <path d="M148 212h32v63h-32Z" fill="#c7e6f5" />
        <path d="M188 212v-14h21v14" fill="#c7e6f5" />
        <path d="M209 211c-4-7 0-26 7-32 8 10 12 24 7 32Z" fill="#69bcef" />
        <path d="M216 194v17" />
        <path d="M144 212h105v11H144Z" fill="#fff" />
        <rect x="193" y="242" width="25" height="24" fill="#45BFF4" />
      </g>
      <g data-building="low-rise">
        <path d="M30 143h118v132H30Z" fill="#E5F4FF" />
        <path d="M30 143h47v132H30Z" fill="#ffffff" />
        {[[44, 159], [44, 203], [44, 247], [99, 159], [99, 203], [99, 247]].map(([x, y]) =>
          <rect key={`${x}-${y}`} x={x} y={y} width="20" height="22" fill={x < 77 ? '#BFE7F7' : '#45BFF4'} />)}
        <path d="M39 132c-10-10-3-33 3-40 8 11 15 29 6 40Z" fill="#69bcef" />
        <path d="M42 111v21m-5-10 5 5 5-5" />
        <path d="M57 132v-17h22v17m-28-17h34v-6H51Z" fill="#fff" />
        <path d="M83 132c0-10 14-14 19-3 7-9 18-6 19 3Z" fill="#c7e6f5" />
        <path d="M24 132h132v11H24Z" fill="#fff" />
        <path d="M77 132h79v11H77Z" fill="#c7e6f5" />
      </g>
      <path d="M24 275h357" />
    </g>
  </svg>
}

export function TemperatureDiagram() {
  return <svg className="software-diagram" viewBox="0 0 360 280" fill="none" aria-hidden="true" data-art-style="flat">
    <rect className="software-temperature-panel" x="10" y="10" width="340" height="260" rx="8" fill="#fff" />
    <circle cx="180" cy="140" r="108" stroke="#c5d7e8" strokeWidth="14" />
    <path d="M104 216a108 108 0 1 1 152 0" stroke="#075dd5" strokeWidth="14" strokeLinecap="round" />
    <text x="180" y="152" textAnchor="middle" fontSize="56" fontWeight="450" fill="#24465e">22℃</text>
    <path data-control="decrease" d="M26 140h20" stroke="#365577" strokeWidth="2" strokeLinecap="round" />
    <path data-control="increase" d="M314 140h20m-10-10v20" stroke="#365577" strokeWidth="2" strokeLinecap="round" />
  </svg>
}
